import { ConfiguredPermissions } from './configured-permissions';
import { UserGroup } from './user-group';
export class SecuritySettings {
  constructor(
    public defaultCustomerUserGroups?: UserGroup[],
    public defaultCustomerPermissions?: ConfiguredPermissions,
    public registrationEmailFromAddress?: string,
    public enableUserRegistration?: boolean,
    public enableUserInvites?: boolean,
    public selfRegisteredUserGroup?: string | null
  ) {}
}
